import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import appStoreLogo from '../assets/app_store_logo.svg';
import playStoreLogo from '../assets/play_store_logo.svg';

// MAQUETTE du nouvel accueil (positionnement « écosystème connecté »).
// Page de travail locale (/accueil-v2), à valider avant de remplacer l'accueil actuel.
const ASSET = `${process.env.PUBLIC_URL || ''}/assets/app-marchand/`;
const TEAL = '#113039';

const SOLUTIONS = [
  { label: 'E-commerçants et marchands', href: '/app', text: 'Boutique, livraison et paiement à la livraison' },
  { label: 'Sociétés de livraison', href: '#societes-livraison', text: 'Recevez des courses, gérez vos livreurs' },
  { label: 'Livreurs', href: '/become-partner', text: 'Gagnez de l’argent avec l’app livreur' },
  { label: 'Particuliers', href: '/quick-delivery', text: 'Envoyez et suivez un colis' },
];

const PROBLEMS = [
  ['💬', 'Des commandes perdues dans les messages', 'Prix, tailles, adresse : chaque vente demande des dizaines de messages, et certaines se perdent.'],
  ['📍', 'Des livraisons difficiles à organiser', 'Adresses introuvables, livreurs à appeler un par un, aucune visibilité sur la course.'],
  ['💸', 'Un argent difficile à suivre', 'Le paiement à la livraison passe de main en main, sans trace claire de ce qui est dû.'],
];

const PILLARS = [
  {
    title: 'Une app pour chacun',
    text: 'Marchand, livreur, société de livraison : chacun a son outil, pensé pour son métier, sur mobile et sur ordinateur.',
    img: 'hero.webp',
    alt: 'L’app marchand OuiGoo et une boutique en ligne',
  },
  {
    title: 'Tout se parle',
    text: 'La commande passe de votre boutique (ou de Shopify) au livreur, puis à l’encaissement, sans rien ressaisir.',
    img: 'laptop.webp',
    alt: 'Commandes synchronisées dans l’espace OuiGoo',
  },
  {
    title: 'Chaque franc est tracé',
    text: 'Chaque commande, livraison et paiement est enregistré, puis vous est reversé avec le détail par commande.',
    img: '15.webp',
    alt: 'Détail d’un paiement collecté à la livraison',
  },
];

const FLOW = [
  ['🛍️', 'Commande', 'Sur votre boutique, WhatsApp ou Shopify'],
  ['📦', 'Expédition', 'En 1 clic, vos livreurs ou le Réseau OuiGoo'],
  ['🛵', 'Livraison', 'Suivie en direct jusqu’à la position du client'],
  ['💬', 'Client prévenu', 'Notifications WhatsApp à chaque étape'],
  ['💰', 'Encaissement', 'Le livreur collecte le paiement'],
  ['🏦', 'Reversement', 'Avec le détail, commande par commande'],
];

const ACTORS = [
  { title: 'E-commerçants', text: 'Boutique en ligne gratuite, livraison et paiement à la livraison.', img: '13.webp', href: '/app', cta: 'Découvrir' },
  { title: 'Sociétés de livraison', text: 'Recevez des courses et gérez vos livreurs depuis le portail partenaire.', img: '14.webp', href: '#societes-livraison', cta: 'Devenir partenaire' },
  { title: 'Livreurs', text: 'Recevez des courses près de vous et suivez vos gains dans l’app livreur.', img: 'photo_livreur.jpg', href: '/become-partner', cta: 'Devenir livreur' },
  { title: 'Particuliers', text: 'Envoyez un colis en quelques clics et suivez-le en temps réel.', img: null, href: '/quick-delivery', cta: 'Envoyer un colis' },
];

const CLIENTS = ['CHIVI', 'FAFA Styles', 'Don&co Accessories', 'Horizon'];

// Chiffres à fournir (valeurs réelles uniquement).
const STATS = [
  ['À fournir', 'marchands actifs'],
  ['À fournir', 'livraisons effectuées'],
  ['À fournir', 'FCFA encaissés à la livraison'],
];

const INTEGRATIONS = [
  { name: 'Shopify', color: '#5E8E3E', note: 'Application sur le Shopify App Store', href: 'https://apps.shopify.com/ouigoo' },
  { name: 'WooCommerce', color: '#723C66', note: 'Connexion depuis business.ouigoo.co' },
  { name: 'PrestaShop', color: '#DF0067', note: 'Connexion depuis business.ouigoo.co' },
  { name: 'API', color: '#333333', note: 'Pour vos outils sur mesure' },
];

const FAQ = [
  ['OuiGoo, c’est seulement pour les boutiques en ligne ?', 'Non. Vous pouvez utiliser OuiGoo pour vendre en ligne, pour faire livrer vos commandes, pour encaisser à la livraison, ou pour tout à la fois.'],
  ['Combien ça coûte ?', 'La boutique est gratuite : 0 FCFA par mois. Vous payez uniquement les livraisons du Réseau OuiGoo, quand vous l’utilisez.'],
  ['Je suis une société de livraison, comment travailler avec OuiGoo ?', 'Rejoignez le réseau partenaire : vous recevez des courses et gérez vos livreurs depuis le portail partenaire. Parlez-en à un conseiller.'],
  ['Comment suis-je payé ?', 'Chaque paiement collecté à la livraison remonte dans votre solde, puis vous est reversé avec le détail par commande.'],
];

function NavV2() {
  const [open, setOpen] = useState(false);
  const [mobile, setMobile] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-gray-100 bg-white/95 backdrop-blur">
      <nav className="mx-auto flex max-w-screen-2xl items-center gap-6 px-5 py-4 md:px-16">
        <a href="/accueil-v2" className="text-3xl font-bold">
          <span style={{ color: TEAL }}>Oui</span>
          <span className="text-primary-custom">Goo</span>
        </a>
        <div className="hidden items-center gap-6 font-semibold text-gray-800 lg:flex">
          <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
            <button type="button" className="py-2" aria-expanded={open} onClick={() => setOpen(o => !o)}>
              Solutions ▾
            </button>
            {open ? (
              <div className="absolute left-0 top-full w-80 rounded-2xl border border-gray-100 bg-white p-2 shadow-xl">
                {SOLUTIONS.map(s => (
                  <a key={s.label} href={s.href} className="block rounded-xl px-4 py-3 hover:bg-gray-50">
                    <span className="block font-semibold text-gray-900">{s.label}</span>
                    <span className="block text-sm font-normal text-gray-500">{s.text}</span>
                  </a>
                ))}
              </div>
            ) : null}
          </div>
          <a href="#integrations">Intégrations</a>
          <a href="/get-quote">Tarifs</a>
          <a href="/tracking">Suivre un colis</a>
        </div>
        <div className="ml-auto hidden items-center gap-3 lg:flex">
          <a href="https://business.ouigoo.co" className="px-3 py-2 font-semibold text-gray-800">
            Connexion
          </a>
          <a href="/app#rendez-vous" className="rounded-lg bg-primary-custom px-5 py-2.5 font-semibold text-white">
            Parler à un conseiller
          </a>
        </div>
        <button type="button" className="ml-auto text-2xl lg:hidden" aria-label="Menu" onClick={() => setMobile(m => !m)}>
          ☰
        </button>
      </nav>
      {mobile ? (
        <div className="space-y-1 border-t border-gray-100 px-5 pb-5 lg:hidden">
          {SOLUTIONS.map(s => (
            <a key={s.label} href={s.href} className="block py-2 font-semibold text-gray-800">
              {s.label}
            </a>
          ))}
          <a href="#integrations" className="block py-2 font-semibold text-gray-800">Intégrations</a>
          <a href="/get-quote" className="block py-2 font-semibold text-gray-800">Tarifs</a>
          <a href="/tracking" className="block py-2 font-semibold text-gray-800">Suivre un colis</a>
          <a href="/app#rendez-vous" className="mt-2 block rounded-lg bg-primary-custom px-5 py-3 text-center font-semibold text-white">
            Parler à un conseiller
          </a>
        </div>
      ) : null}
    </header>
  );
}

function SectionTitle({ kicker, title, text, light, left }) {
  return (
    <div className={left ? 'max-w-xl' : 'mx-auto max-w-3xl text-center'}>
      {kicker ? <p className="text-sm font-semibold uppercase tracking-wider text-primary-custom">{kicker}</p> : null}
      <h2 className={`mt-2 text-3xl font-bold leading-tight lg:text-5xl ${light ? 'text-white' : 'text-gray-900'}`}>{title}</h2>
      {text ? <p className={`mt-4 lg:text-lg ${light ? 'text-white/75' : 'text-gray-600'}`}>{text}</p> : null}
    </div>
  );
}

export default function HomeV2() {
  const navigate = useNavigate();
  const [trackId, setTrackId] = useState('');
  const [flowStep, setFlowStep] = useState(0);

  useEffect(() => {
    document.title = 'OuiGoo | Vendez, livrez, encaissez. Tout est connecté.';
    const t = setInterval(() => setFlowStep(s => (s + 1) % FLOW.length), 1400);
    return () => clearInterval(t);
  }, []);

  const track = e => {
    e.preventDefault();
    const id = trackId.trim();
    navigate(id ? `/tracking?tracking-id=${encodeURIComponent(id)}&submit=1` : '/tracking');
  };

  return (
    <div className="min-h-screen bg-white font-inter text-gray-800">
      <div className="bg-amber-100 px-4 py-2 text-center text-sm font-semibold text-amber-900">
        Maquette du nouvel accueil, visible uniquement en local
      </div>
      <NavV2 />

      <main>
        {/* 1. HERO */}
        <section className="bg-[#f3ece4] py-14 lg:py-20">
          <div className="mx-auto grid max-w-screen-2xl items-center gap-10 px-5 md:px-16 lg:grid-cols-[0.9fr_1.1fr]">
            <div>
              <h1 className="text-4xl font-extrabold leading-tight text-gray-900 lg:text-6xl">
                Vendez, livrez, encaissez. <span className="text-primary-custom">Tout est connecté.</span>
              </h1>
              <p className="mt-5 max-w-xl text-lg text-gray-600">
                OuiGoo réunit votre boutique en ligne, vos livraisons et vos paiements à la livraison dans un seul
                écosystème, avec une trace de chaque transaction.
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <a href="/app#rendez-vous" className="inline-flex items-center justify-center rounded-lg bg-primary-custom px-7 py-3 font-semibold text-white">
                  Parler à un conseiller
                </a>
                <a href="#plateforme" className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-7 py-3 font-semibold text-gray-800">
                  Découvrir la plateforme
                </a>
              </div>
              <form onSubmit={track} className="mt-8 flex max-w-md overflow-hidden rounded-lg border border-gray-300 bg-white">
                <input
                  value={trackId}
                  onChange={e => setTrackId(e.target.value)}
                  placeholder="Numéro de suivi d’un colis"
                  className="min-w-0 flex-1 px-4 py-3 text-sm outline-none"
                />
                <button type="submit" className="px-4 text-sm font-semibold" style={{ color: TEAL }}>
                  Suivre
                </button>
              </form>
            </div>
            <img src={`${ASSET}hero.webp`} alt="L’app marchand OuiGoo et une boutique en ligne" width="1600" height="1100" className="h-auto w-full" />
          </div>
        </section>

        {/* 2. LE PROBLÈME */}
        <section className="py-14 lg:py-20">
          <div className="mx-auto max-w-screen-2xl px-5 md:px-16">
            <SectionTitle title="Vendre, vous savez déjà. C’est tout le reste qui vous freine." />
            <div className="mt-10 grid gap-5 md:grid-cols-3">
              {PROBLEMS.map(([icon, title, text]) => (
                <div key={title} className="rounded-2xl border border-gray-200 bg-gray-50 p-6">
                  <div className="text-3xl" aria-hidden="true">{icon}</div>
                  <p className="mt-3 text-lg font-bold text-gray-900">{title}</p>
                  <p className="mt-2 text-gray-600">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. LES 3 PILIERS */}
        <section id="plateforme" className="py-14 text-white lg:py-20" style={{ background: TEAL }}>
          <div className="mx-auto max-w-screen-2xl px-5 md:px-16">
            <SectionTitle
              light
              kicker="La plateforme OuiGoo"
              title="Des plateformes dédiées, un seul écosystème connecté"
              text="Chaque acteur du e-commerce a son outil. Ensemble, ils forment une seule chaîne, de la commande à l’encaissement."
            />
            <div className="mt-12 grid gap-6 lg:grid-cols-3">
              {PILLARS.map((p, i) => (
                <article key={p.title} className="overflow-hidden rounded-3xl bg-white/5 ring-1 ring-white/10">
                  <div className="flex h-56 items-center justify-center bg-white/5 p-4">
                    <img src={`${ASSET}${p.img}`} alt={p.alt} loading="lazy" className="max-h-full w-auto object-contain" />
                  </div>
                  <div className="p-6">
                    <p className="text-sm font-bold text-primary-custom">0{i + 1}</p>
                    <p className="mt-1 text-xl font-bold">{p.title}</p>
                    <p className="mt-2 text-white/75">{p.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* 4. COMMENT ÇA CIRCULE */}
        <section className="py-14 lg:py-20">
          <div className="mx-auto max-w-screen-2xl px-5 md:px-16">
            <SectionTitle title="Une commande, de bout en bout" text="Chaque étape est reliée à la suivante et enregistrée." />
            <ol className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
              {FLOW.map(([icon, title, text], i) => {
                const on = i === flowStep;
                const done = i < flowStep;
                return (
                  <li
                    key={title}
                    className={`relative rounded-2xl border p-5 text-center transition duration-500 ${
                      on ? 'scale-105 border-primary-custom bg-orange-50 shadow-lg' : done ? 'border-gray-200 bg-white' : 'border-gray-200 bg-gray-50'
                    }`}
                  >
                    <div className="text-3xl" aria-hidden="true">{icon}</div>
                    <p className="mt-2 font-bold text-gray-900">{title}</p>
                    <p className="mt-1 text-sm text-gray-600">{text}</p>
                    <span className={`absolute right-3 top-3 h-2.5 w-2.5 rounded-full ${on || done ? 'bg-primary-custom' : 'bg-gray-300'}`} aria-hidden="true" />
                  </li>
                );
              })}
            </ol>
          </div>
        </section>

        {/* 5. UNE PLATEFORME POUR CHAQUE ACTEUR */}
        <section id="societes-livraison" className="bg-gray-50 py-14 lg:py-20">
          <div className="mx-auto max-w-screen-2xl px-5 md:px-16">
            <SectionTitle title="Une plateforme pour chaque acteur" />
            <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {ACTORS.map(a => (
                <a key={a.title} href={a.href} className="group overflow-hidden rounded-2xl border border-gray-200 bg-white transition hover:shadow-lg">
                  {a.img ? (
                    <img src={`${ASSET}${a.img}`} alt="" loading="lazy" className="block aspect-[6/5] w-full object-cover" />
                  ) : (
                    <div className="flex aspect-[6/5] w-full items-center justify-center text-7xl" style={{ background: TEAL }} aria-hidden="true">
                      📦
                    </div>
                  )}
                  <div className="p-6">
                    <p className="text-xl font-bold text-gray-900">{a.title}</p>
                    <p className="mt-2 text-gray-600">{a.text}</p>
                    <p className="mt-4 font-semibold text-primary-custom group-hover:underline">{a.cta} →</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* 6. PREUVE */}
        <section className="py-14 lg:py-20">
          <style>{`
            @keyframes v2-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
            .v2-track { animation: v2-marquee 30s linear infinite; }
            @media (prefers-reduced-motion: reduce) { .v2-track { animation: none; } }
          `}</style>
          <div className="mx-auto max-w-screen-2xl px-5 md:px-16">
            <SectionTitle title="Ils vendent déjà avec OuiGoo" />
          </div>
          <div
            className="mt-8 overflow-hidden"
            style={{
              WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)',
              maskImage: 'linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)',
            }}
          >
            <ul className="v2-track flex w-max items-center">
              {[0, 1].map(half =>
                [...CLIENTS, ...CLIENTS].map((name, i) => (
                  <li
                    key={`${half}-${i}`}
                    aria-hidden={half === 1 || i >= CLIENTS.length ? true : undefined}
                    className="flex items-center whitespace-nowrap px-6 text-2xl font-extrabold uppercase tracking-wide text-gray-800 lg:px-10 lg:text-4xl"
                  >
                    {name}
                    <span className="ml-12 inline-block h-2.5 w-2.5 rounded-full bg-primary-custom lg:ml-20" aria-hidden="true" />
                  </li>
                ))
              )}
            </ul>
          </div>
          <div className="mx-auto mt-12 grid max-w-4xl gap-4 px-5 sm:grid-cols-3">
            {STATS.map(([value, label]) => (
              <div key={label} className="rounded-2xl border-2 border-dashed border-amber-300 bg-amber-50 p-6 text-center">
                <p className="text-3xl font-extrabold text-amber-700">{value}</p>
                <p className="mt-1 text-gray-600">{label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 7. INTÉGRATIONS */}
        <section id="integrations" className="bg-[#1f2127] py-14 text-white lg:py-20">
          <div className="mx-auto grid max-w-screen-2xl items-center gap-10 px-5 md:px-16 lg:grid-cols-2">
            <div>
              <SectionTitle
                light
                left
                title={'Déjà une boutique en ligne ? Connectez-la.'}
                text="Vos commandes Shopify, WooCommerce ou PrestaShop arrivent dans OuiGoo et partent en livraison."
              />
              <div className="mt-8 grid gap-3 sm:grid-cols-2">
                {INTEGRATIONS.map(it => {
                  const body = (
                    <>
                      <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl text-sm font-bold" style={{ background: it.color }}>
                        {it.name[0]}
                      </span>
                      <span>
                        <span className="block font-semibold">{it.name}</span>
                        <span className="block text-sm text-white/70">{it.note}</span>
                      </span>
                    </>
                  );
                  return it.href ? (
                    <a key={it.name} href={it.href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-2xl bg-white/5 p-4 ring-1 ring-white/10 hover:bg-white/10">
                      {body}
                    </a>
                  ) : (
                    <div key={it.name} className="flex items-center gap-3 rounded-2xl bg-white/5 p-4 ring-1 ring-white/10">
                      {body}
                    </div>
                  );
                })}
              </div>
            </div>
            <img src={`${ASSET}integrations.webp`} alt="Écran Intégrations de l’app OuiGoo" loading="lazy" className="mx-auto h-auto w-full max-w-[300px]" />
          </div>
        </section>

        {/* 8. FAQ + CTA */}
        <section className="py-14 lg:py-20">
          <div className="mx-auto grid max-w-screen-2xl gap-10 px-5 md:px-16 lg:grid-cols-[0.8fr_1.2fr]">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 lg:text-5xl">Questions fréquentes</h2>
              <p className="mt-3 text-gray-600 lg:text-lg">Boutique, livraison, encaissement : un conseiller répond à vos besoins.</p>
              <a href="/app#rendez-vous" className="mt-6 inline-flex rounded-lg bg-primary-custom px-6 py-3 font-semibold text-white">
                Parler à un conseiller
              </a>
              <div className="mt-6 flex gap-3">
                <a href="/go/app-store"><img src={appStoreLogo} alt="App Store" className="h-11" /></a>
                <a href="/go/play-store"><img src={playStoreLogo} alt="Google Play" className="h-11" /></a>
              </div>
            </div>
            <div className="space-y-3">
              {FAQ.map(([q, a]) => (
                <details key={q} className="rounded-xl border border-gray-200 bg-gray-50 p-5">
                  <summary className="cursor-pointer font-semibold text-gray-900">{q}</summary>
                  <p className="mt-2 text-sm text-gray-600">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
